<div class="flex flex-col items-center gap-4 text-center text-text-secondary">
  <h4 class="text-h4 font-medium">{{ 'site_setup_form_sent_success_button' | translate }}</h4>
  <p class="typo-h5-book">{{ 'site_setup_form_sent_modal_text1' | translate }}</p>
  <h5 class="typo-h5-semibold-5p">{{ 'site_setup_form_sent_modal_text2' | translate }}</h5>
  <p class="typo-h5-book">{{ 'site_setup_form_sent_modal_text3' | translate }}</p>
  <p class="typo-h5-book">{{ 'site_setup_form_sent_modal_text4' | translate }}</p>

  <button class="btn-primary mt-4 h-10 w-fit" (click)="onCloseClick()">
    {{ 'site_setup_form_sent_modal_button' | translate }}
  </button>
</div>
